import Text from 'components/_core/Text';

type ListHeadingProps = {
  title: string;
  description?: string;
};

const ListHeading = ({ description, title }: ListHeadingProps) => (
  <>
    <Text
      fontWeight="weight-500"
      paddingBottom="space-4"
      size="lg"
      variant="primary"
    >
      {title}
    </Text>

    {description ? <Text paddingBottom="space-16">{description}</Text> : null}
  </>
);

export default ListHeading;
